<script>
import axios from 'axios';
import snackbarMixin from '@/mixins/snackbar';
import paginationMixin from '@/mixins/pagination';
import downloader from '@/mixins/downloader';
import RbxFileUpload from '@/shared/reybex/RbxFileUpload';
import LogListItem from './LogListItem';

export default {
  name: 'CsvImportDialog',
  components: {
    RbxFileUpload,
    LogListItem,
  },
  mixins: [snackbarMixin, paginationMixin, downloader],
  data() {
    return {
      isFileProcessed: false,
      visible: false,
      uploadStartTime: null,
      logList: [],
      headers: [{ text: 'Importiert', value: 'imported' }, { text: 'Name', value: 'name' },
        { text: 'Fehler', value: 'errorMessages' }, { text: 'Warnungen', value: 'warningMessages' }],

    };
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    close() {
      this.$emit('cancel');
    },
    addFile() {
      this.isFileProcessed = true;
      this.uploadStartTime = Date.now();
      console.log('timestamp', this.uploadStartTime);
    },
    onUpload() {
      axios.get(`/employeeImportLog?uploadId=${this.uploadStartTime}`)
        .then(({ data }) => {
          this.logList = data;
          this.$emit('imported');
        });
    },
    onError() {
      this.showErrorMessage('Die Datei konnte nicht importiert werden. Erlaubt sind nur Dateien, die der CSV-Vorlage entsprechen. Zeilenumbrüche sind nicht erlaubt.');
    },
    downloadCsvTemplate() {
      return axios.get('/employee/csvTemplate', {
        responseType: 'blob',
        timeout: 30000,
      }).then((response) => {
        this.getDownloadContent(response, 'Mitarbeiter-Import-Vorlage.csv');
      }).catch(() => {
        this.showErrorMessage('Beim Herunterladen der Vorlage ist ein Fehler aufgetreten.');
      });
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        CSV-Import
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex md12 xs12>

              <v-flex xs12 md12>
                Die Mitarbeiter werden bei Auswahl der Datei direkt importiert.
                Wenn Sie Rückmeldung über das Import-Ergebnis erhalten wollen,
                lassen Sie das Popup-Fenster bitte geöffnet.
                <br><br>
                Erlaubt sind CSV-Dateien, die der Vorlage entsprechen:
                <a @click="downloadCsvTemplate()">Import-Vorlage</a>
                <br><br>
                <b>
                  Wichtig: Wenn Sie die CSV-Vorlage in EXCEL bearbeiten,
                  stellen Sie bitte alle Zellen auf das Format "Text".
                  Ansonsten können führende Nullen verloren gehen.
                </b>
                <RbxFileUpload
                  height="100"
                  :file-resource="'employee/csv?uploadId=' + uploadStartTime"
                  :allow-multiple="false"
                  @uploaded="onUpload"
                  @addfile="addFile"
                  @error="onError"
                />
              </v-flex>

              <v-flex xs12 md12 v-if="this.logList.length > 0">
                <v-data-table
                  :headers="headers"
                  :items="logList"
                  :disable-initial-sort="true"
                  :pagination="pagination"
                  :rows-per-page-items="rowsPerPageItems"
                  :total-items="this.pagination.totalItems"
                  :expand="true"
                  item-key="id"
                  @update:pagination="loadNextPage"
                  rows-per-page-text="Zeilen pro Seite"
                  no-data-text="keine Daten verfügbar"
                  class="elevation-1 js-table"
                >
                  <template slot="items" slot-scope="props">
                    <log-list-item :log="props.item" :expanded="props.expanded" />
                  </template>
                  <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                    von {{ pageStart }} bis {{ pageStop }}
                  </template>
                </v-data-table>
              </v-flex>
              <div v-else-if="isFileProcessed">
                <v-progress-linear :indeterminate="true"/>
                Importiere ...
              </div>

            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>

        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
